import React, { FC } from 'react'
import SuperAdmin from './SuperAdmin';


const SuperAdminWrapper: FC = () => {
    return (
        <>
            <SuperAdmin />
        </>
    )
}

export default SuperAdminWrapper;
